// Events for amplitude tracking
export enum AdminNominationTrackingEvent {
	// Index page actions
	CreateNominationPeriod = 'Admin Create Nomination Period',
	SelectNominationPeriod = 'Admin Select a Nomination Period',
	ShareNominationPeriod = 'Admin Share Nomination Period',
	ReviewSubmissions = 'Admin Review Nomination Period Submissions',
	ExportCSV = 'Admin Nomination Period Export to CSV',
	EditNominationPeriod = 'Admin Edit Nomination Period',

	// Nomination Period detail actions
	DownloadCSV = 'Admin Download CSV',
	ShareResults = 'Admin Share Nomination Period Results',
	MakePublic = 'Admin Make Nomination Period Public',
	GiveAward = 'Admin Nomination Give Award',
	CreateAward = 'Admin Nomination Create Award',
	GiveRecognition = 'Admin Nomination Give Recognition',
	CopyMessages = 'Admin Nomination Copy Messages',
	FavoriteNominee = 'Admin Nomination Favorite Nominee',
	UnfavoriteNominee = 'Admin Nomination Unfavorite Nominee',
}

export enum UserNominationTrackingEvent {
	OpenNominationModal = 'User Nominate a User',
	SelectNominationPeriod = 'User Select a Nomination Period',
	SubmitNomination = 'User Submit Nomination',
}
